export default __webpack_public_path__ + "static/media/fullscreen-button.3f82cafb.png";